import { useHasOnboardingAutoOpened, useIsOnboardingOpen } from '../store/onboardingStore';
import { useOnboardingEligibility } from './useOnboardingEligibility';

/** Open, or due but not opened yet: the dialog mounts with the layout, after the space has resolved. */
export function useIsOnboardingInProgress() {
  const isOpen = useIsOnboardingOpen();
  const hasAutoOpened = useHasOnboardingAutoOpened();
  const { isDue } = useOnboardingEligibility();

  return isOpen || (isDue && !hasAutoOpened);
}
